import React from 'react';
import { render } from 'react-dom';
import AppGuest from '../../../src/app/guest';

render(<AppGuest />, document.getElementById('root'));